<onboarding-container
  [displayProgressBar]="false"
  [formValid]="amount$ | async | savingsPlanAmount"
  [buttonLabel]="'onboarding.savings-plan.create.btn' | transloco"
  (forward)="goForward()"
  (back)="goBack()"
>
  <p class="zero-text p-huge-med">{{ 'onboarding.savings-plan.create.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'onboarding.savings-plan.create.text' | transloco }}</p>
  <web-design-system-input
    type="number"
    [label]="'onboarding.savings-plan.create.amount' | transloco"
    [value]="amount$ | async"
    [isValid]="amount$ | async | savingsPlanAmount"
    [error]="(amount$ | async | savingsPlanAmount) === false ? ('onboarding.savings-plan.create.amount-error' | transloco) : null"
    (valueChange)="handleAmountChange($event)"
  />
</onboarding-container>
